import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card-arquivo-anexado',
  templateUrl: './card-arquivo-anexado.component.html',
  styleUrls: ['./card-arquivo-anexado.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class CardArquivoAnexadoComponent {
  @Input() arquivo!: ArquivoAzure;
  @Input() index: number = 0;
  @Input() showRemoveButton: boolean = true;

  @Output() visualizar = new EventEmitter<number>();
  @Output() download = new EventEmitter<number>();
  @Output() remover = new EventEmitter<number>();

  onVisualizarClick(): void {
    this.visualizar.emit(this.index);
  }

  onDownloadClick(): void {
    this.download.emit(this.index);
  }

  onRemoverClick(): void {
    this.remover.emit(this.index);
  }
}
